import { IUserDataModel } from '../../data-models/user.data-model';
import { MaggieHttp } from '../MaggieHttp';

export async function fetchUsersByType(userType: string): Promise<IUserDataModel[]> {
  const { data } = await MaggieHttp.maggie.get<IUserDataModel[]>('/user', {
    params: { userType },
  });

  return data;
}
